import React from 'react';
import PerinatalHistory from './PerinatalHistory';
import FeedingSection from './FeedingSection';
import GrowthSection from './GrowthSection';
import DevelopmentMilestones from './DevelopmentMilestones';
import VaccinationSchedule from './VaccinationSchedule';
import SectionNumberBadge from '../SectionNumberBadge';

interface PediatricData {
  perinatal: {
    gestational_age_weeks: number | null;
    delivery_type: string;
    birth_weight_g: number | null;
    birth_height_cm: number | null;
    birth_head_cm: number | null;
    apgar_1min: number | null;
    apgar_5min: number | null;
    perinatal_complications: string;
  };
  feeding: {
    type: string;
    ablactation_start_month: number | null;
    formula_name: string;
    food_allergies: string;
  };
  growth: {
    weight_kg: number | null;
    height_cm: number | null;
    head_cm: number | null;
    measurement_method: string;
    weight_percentile: number | null;
    height_percentile: number | null;
    head_percentile: number | null;
    bmi: number | null;
    bmi_percentile: number | null;
  };
  milestones: Array<{ area: string; milestone: string; achieved: boolean }>;
  milestones_observations: string;
  vaccines: Array<{ vaccine: string; dose: string; applied: boolean; date: string | null }>;
  vaccination_status: string;
  vaccination_observations: string;
}

interface Props {
  pediatricData: PediatricData;
  setPediatricField: (section: string, field: string, value: any) => void;
  patientBirthDate: string | null;
  patientGender: boolean | null;
  sectionNumber?: string;
}

const PediatricSection: React.FC<Props> = ({
  pediatricData,
  setPediatricField,
  patientBirthDate,
  patientGender,
  sectionNumber,
}) => {
  return (
    <div className="row mb-4" data-section="pediatrica">
      <div className="col-sm-12">
        <div className="card border-info">
          <div className="card-header text-white" style={{ backgroundColor: '#0d9488' }}>
            <h4 className="card-title mb-0">
              {sectionNumber && <SectionNumberBadge number={sectionNumber} inverse />}
              <i className="fa fa-child me-2"></i>
              Evaluación Pediátrica
            </h4>
          </div>
          <div className="card-body">
            {patientBirthDate && patientGender !== null && (
              <div className="alert alert-info py-2 mb-3 small">
                <i className="fa fa-info-circle me-1"></i>
                Paciente de {patientGender ? 'masculino' : 'femenino'} — Fecha de nacimiento:{' '}
                {new Date(patientBirthDate).toLocaleDateString('es-DO')}
              </div>
            )}

            <PerinatalHistory
              perinatal={pediatricData.perinatal}
              setPediatricField={setPediatricField}
            />

            <FeedingSection
              feeding={pediatricData.feeding}
              setPediatricField={setPediatricField}
            />

            <GrowthSection
              growth={pediatricData.growth}
              setPediatricField={setPediatricField}
              patientBirthDate={patientBirthDate}
            />

            <DevelopmentMilestones
              milestones={pediatricData.milestones}
              milestones_observations={pediatricData.milestones_observations}
              setPediatricField={setPediatricField}
              patientBirthDate={patientBirthDate}
            />

            <VaccinationSchedule
              vaccines={pediatricData.vaccines}
              vaccination_status={pediatricData.vaccination_status}
              vaccination_observations={pediatricData.vaccination_observations}
              setPediatricField={setPediatricField}
              patientBirthDate={patientBirthDate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PediatricSection;
